import { apiClient } from '@/shared/services/http/http.service.js'

class LanguageService {
  constructor() {
    this.client = apiClient('core')
  }

  async getAvailableLanguages() {
    const response = await this.client.get('master-data/platform-languages')
    return response.data
  }

  async updateDefaultLanguage(userId, language) {
    return this.client.put(`/identity/users/${userId}/default-language`, {
      defaultLanguage: language,
    })
  }
}

export function getLanguageService() {
  return new LanguageService()
}
